import { gql } from "graphql-tag";

export const getActivitiesGQL = gql`
  query Me($input: ActivitiesInput) {
    me {
      activities(input: $input) {
        total
        items {
          activityType
          createdAt
          data {
            ... on BattleActivityData {
              rank
              winner
              battleId
              battleType
              timePlayed
              opponentUsers {
                id
                username
                xp
                avatar
                lastActive {
                  time
                }
              }
              prize {
                amount
                coinType
              }
              game {
                id
                title
                metadata
              }
              moment {
                challengeNumber
              }
            }
            ... on LeaderboardActivityData {
              timeFrame
              endDate
              leaderboardRank
              type
            }
            ... on UserLeaderboardActivityData {
              __typename
              endDate
              leaderboardId
              leaderboardRank
              repeatCycle
              score
            }
            ... on LoginRewardActivityData {
              __typename
              prizeAmount
              prizeCoinType
            }
          }
          id
        }
      }
    }
  }
`;

export const getTotalActivitiesGQL = gql`
  query Me($input: ActivitiesInput) {
    me {
      activities(input: $input) {
        total
      }
    }
  }
`;
